'use client';

import { useSession, authClient } from '@/lib/auth-client';
let lastSession: typeof authClient.$Infer.Session = null;
export function getLastSession() {
  return lastSession;
}
export function AuthSessionProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    data: session,
    isPending
  } = useSession();
  lastSession = session;
  return <>{children}</>;
}